module.exports = __webpack_public_path__ + "static/media/mbl_adult_logo.9eb3fdf4.svg";